export class CreateSSRDocumentDTO {
  surveyId: string;

  constructor(data: { surveyId: string }) {
    this.surveyId = data.surveyId;
  }
}
